import React, { useState } from "react";
import InputField from "../input/inputField";
import { Button } from "../Button";
import { login } from "../../Services/users/users.service";
import { useDispatch } from "react-redux";
import { setErrorMessage } from "../../Redux/Slices/alert.slice";
import { EMAIL_REGEX } from "../../Constants/regex";
import {
  EMAIL_REQUIRED,
  INVALID_EMAIL_MESSAGE,
  PASSWORD_REQUIRED,
} from "../../Constants/messages";
import { useNavigate } from "react-router-dom";

interface Props {
  header: string;
  subHeader: string;
}
const Login = ({ header, subHeader }: Props) => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validate = () => {
    if (!email) {
      dispatch(setErrorMessage(EMAIL_REQUIRED));
      return false;
    }
    if (!EMAIL_REGEX.test(email)) {
      dispatch(setErrorMessage(INVALID_EMAIL_MESSAGE));
      return false;
    }
    if (!password) {
      dispatch(setErrorMessage(PASSWORD_REQUIRED));
      return false;
    }
    return true;
  };

  const onLogin = () => {
    if (!validate()) return;
    login({ email, password })
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        dispatch(setErrorMessage(error.response.data.message));
      });
  };

  return (
    <div>
      <div>
        <InputField value={email} setValue={setEmail} label="Email" />
        <InputField
          value={password}
          setValue={setPassword}
          label="Password"
          isPassword={true}
        />
      </div>
      <div className="h-10 flex justify-end mt-10">
        <Button loading={false} text="Login" onClick={onLogin} />
      </div>
    </div>
  );
};
export default Login;
